// @ts-ignore
import { baseUrl } from '../App';
import Button from './Button';

export default function Navbar({ content }) {
    return (
        <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img src={baseUrl + content.logo.data.attributes.url} alt="Tairi Ehitus" width="96"></img>
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li key={content.menu_element_1} className="nav-item">
                            <a className="nav-link" href={"#" + content.menu_element_1}>{content.menu_element_1}</a>
                        </li>
                        <li key={content.menu_element_2} className="nav-item">
                            <a className="nav-link" href={"#" + content.menu_element_2}>{content.menu_element_2}</a>
                        </li>
                        <li key={content.menu_element_3} className="nav-item">
                            <a className="nav-link" href={"#" + content.menu_element_3}>{content.menu_element_3}</a>
                        </li>
                    </ul>
                    <div className='nav-right-side'>
                        <Button text={content.nupp} href={"#" + content.menu_element_3} type={'btn btn-primary'} />
                    </div>
                </div>
            </div>
        </nav>
    );
}